import { render, staticRenderFns } from "./OtpByDate.vue?vue&type=template&id=4712c363&scoped=true"
import script from "./OtpByDate.vue?vue&type=script&lang=js"
export * from "./OtpByDate.vue?vue&type=script&lang=js"
import style0 from "./OtpByDate.vue?vue&type=style&index=0&id=4712c363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712c363",
  null
  
)

export default component.exports